// import TokenManager from "../classes/TokenManager";
import Session from "../classes/Session";

export default new Session();